import Icon from 'components/Icon';
import { unescape } from 'lodash-es';

const FeaturesItem = ({ icon, title, text }) => (
  <div className="col col-4 col-tablet-portrait-12">
    <div className="_mb-42 _mt-30 _mb-laptop-20">
      <div className="section__icon-wrap _mb-11">
        <Icon icon={icon} />
      </div>
      <h5
        className="title section__title _mb-8"
        dangerouslySetInnerHTML={{ __html: unescape(title) }}
      />
      <p
        className="text section__text"
        dangerouslySetInnerHTML={{ __html: unescape(text) }}
      />
    </div>
  </div>
);

export default FeaturesItem;
